// Sentry environment: the tier variable REACT_APP_ENVIRONMENT only, trimmed and
// lower-cased. Unset gives "unknown", never "production" (no NODE_ENV fallback).
export const sentryEnvironment = (env = process.env) =>
  String(env.REACT_APP_ENVIRONMENT || "")
    .trim()
    .toLowerCase() || "unknown";

// The one test for "may this build send events to Sentry". A DSN must exist
// and the environment must be "production", or REACT_APP_SENTRY_ENABLED must
// be exactly "true" (override for staging checks and rollback).
export const sentryEnabled = (dsn, env = process.env) =>
  Boolean(dsn) &&
  (sentryEnvironment(env) === "production" ||
    env.REACT_APP_SENTRY_ENABLED === "true");
